<template>
  <div class="page-content-wrapper">
    <div class="page-content hello">
    <!-- BEGIN PAGE HEADER-->
    <div class="page-bar">
      <ul class="page-breadcrumb">
        <li>
          <i class="fa fa-home"></i>
          <a href="index.html">首页</a>
          <i class="fa fa-angle-right"></i>
        </li>
        <li>
          <a href="#">关于平台</a>
        </li>
      </ul>
    </div>
    <!-- END PAGE HEADER-->
    <p style="text-align: center;">
      <img src="../assets/kylogo.jpeg" width="20%">
      <h3 style="text-align: center;color:#888">门禁管理系统</h3>
    </p>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex'
import mixins from '../mixins'
export default {
  mixins: mixins,
  name: 'about',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods: {
    changeName () {
      // let les = [1,2,3,4,5,6,7,8,9]
      this.$store.dispatch('changeName')
    }
  },
  computed: {
    ...mapState({
      user: state => state.user
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .hello {
    background-color: #fff;
  }
  p {
    padding: 10px;
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// About.vue?416fcc60